module.exports = __webpack_public_path__ + "img/pro_feature_weather.890706c.png";